import { useState, useEffect } from 'react';
import { message } from 'antd';
import { adminService, RecentActivity } from '../../api/services/adminService';

export const useRecentActivity = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<RecentActivity[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  const fetchRecentActivity = async (pageNum = 1, pageSize = limit) => {
    setLoading(true);
    try {
      const response = await adminService.getRecentActivity(pageNum, pageSize);

      // Handle response structure properly for server-side pagination
      let activities: RecentActivity[] = [];
      let totalCount = 0;

      if (Array.isArray(response)) {
        // If response is direct array (fallback for no pagination)
        activities = response;
        totalCount = response.length;
      } else {
        // If response has the expected structure: { data: { activities: [], pagination: {} } }
        const responseData = response as any;
        activities =
          responseData?.data?.activities || responseData?.activities || [];
        totalCount =
          responseData?.data?.pagination?.total ||
          responseData?.pagination?.total ||
          0;
      }

      setData(activities);
      setTotal(totalCount);
      setPage(pageNum);
      setLimit(pageSize);
    } catch (err) {
      setData([]);
      setTotal(0);
      message.error('Failed to fetch recent activity. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecentActivity(1, limit);
  }, []);

  // Handle window resize for responsive pagination
  useEffect(() => {
    const handleResize = () => {
      const newLimit = window.innerWidth < 1200 ? 5 : 10;
      if (newLimit !== limit) {
        setLimit(newLimit);
        fetchRecentActivity(1, newLimit);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [limit]);

  return {
    loading,
    data,
    total,
    page,
    limit,
    fetchRecentActivity,
    refetch: () => fetchRecentActivity(page, limit),
  };
};
